// Email Notification Service
import { supabase } from '../lib/supabaseClient'

export class EmailService {
  static async sendAppointmentNotification(appointmentData) {
    try {
      // Send notification to admin
      const { error } = await supabase.functions.invoke('send-email', {
        body: {
          name: appointmentData.name,
          email: appointmentData.email,
          phone: appointmentData.phone,
          service: appointmentData.service,
          date: appointmentData.date,
          timeSlot: appointmentData.time_slot,
          message: appointmentData.message
        }
      })

      if (error) throw error
      return { success: true }
    } catch (error) {
      console.error('Error sending appointment notification:', error)
      return { success: false, error: error.message }
    }
  }

  static async sendAppointmentConfirmation(appointmentData) {
    try {
      const { error } = await supabase.functions.invoke('send-email', {
        body: {
          name: appointmentData.name,
          email: appointmentData.email,
          phone: appointmentData.phone,
          service: appointmentData.service,
          date: appointmentData.date,
          timeSlot: appointmentData.time_slot,
          message: `Your appointment has been confirmed. Join link: ${appointmentData.meet_link || ''}`
        }
      })

      if (error) throw error
      return { success: true }
    } catch (error) {
      console.error('Error sending confirmation email:', error)
      return { success: false, error: error.message }
    }
  }

  static async sendWelcomeEmail(userData) {
    try {
      const { error } = await supabase.functions.invoke('send-email', {
        body: {
          to: userData.email,
          subject: 'Welcome to One Matrix',
          template: 'welcome',
          data: {
            userName: userData.name,
            role: userData.role,
            companyName: 'One Matrix',
            dashboardUrl: `${window.location.origin}/${userData.role}`
          }
        }
      })

      if (error) throw error
      return { success: true }
    } catch (error) {
      console.error('Error sending welcome email:', error)
      return { success: false, error: error.message }
    }
  }

  static async sendProjectUpdate(projectData, updateType) {
    try {
      const { error } = await supabase.functions.invoke('send-email', {
        body: {
          to: projectData.client_email,
          subject: `Project Update: ${projectData.name}`,
          template: 'project-update',
          data: {
            clientName: projectData.client_name,
            projectName: projectData.name,
            updateType: updateType,
            projectUrl: `${window.location.origin}/project/${projectData.id}`,
            companyName: 'One Matrix'
          }
        }
      })

      if (error) throw error
      return { success: true }
    } catch (error) {
      console.error('Error sending project update:', error)
      return { success: false, error: error.message }
    }
  }
}
